import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore, useMe, isTokenValid } from '@iziping/common';
import NavBar from '../components/shared/navbar/NavBar';
import ErrorBoundary from '../components/shared/ErrorBoundary';
import { useTranslation } from 'react-i18next';

export const PrivateRoute = () => {
    const { t } = useTranslation();
    const accessToken = useAuthStore((state) => state.accessToken);
    const refreshToken = useAuthStore((state) => state.refreshToken);
    const isAuthenticated = isTokenValid(accessToken) || !!refreshToken;
    const { data: me, isLoading } = useMe();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (isLoading) return null;

    if (!me?.permissions?.includes('TOURNAMENT')) {
        return (
            <div style={{ textAlign: 'center', paddingTop: '4rem' }}>
                <h2>{t('error.forbidden.title')}</h2>
                <p>{t('error.forbidden.message')}</p>
            </div>
        );
    }

    return (
        <>
            <NavBar />
            <ErrorBoundary>
                <Outlet />
            </ErrorBoundary>
        </>
    );
};
